// Public KPIs disclosed in the YES Foundation Annual Reports.
// (Internally still keyed as `TARGETS` for backwards compatibility — the user-facing label is "KPIs".)

export const TARGETS = [
  // ─── Employability ──────────────────────────────────────────────────────────
  {
    id: "youth-1l",
    pillar: "employability",
    label: "Reach 1,00,000 youth with employability & entrepreneurship",
    targetYear: 2026,
    target: 100000,
    actual: 62400,
    unit: "youth",
  },
  {
    id: "women-30pct",
    pillar: "employability",
    label: "Sustain 30%+ women representation in skilling cohorts",
    targetYear: 2026,
    target: 30,
    actual: 32,
    unit: "%",
  },
  {
    id: "placement-75",
    pillar: "employability",
    label: "Achieve 75% placement rate across skilling programmes",
    targetYear: 2026,
    target: 75,
    actual: 70,
    unit: "%",
  },
  {
    id: "first-jobs-15k",
    pillar: "employability",
    label: "Place 15,000 youth in first-time formal jobs",
    targetYear: 2026,
    target: 15000,
    actual: 10200,
    unit: "youth",
  },
  {
    id: "digital-50k",
    pillar: "employability",
    label: "Deliver digital literacy to 50,000 learners",
    targetYear: 2027,
    target: 50000,
    actual: 38500,
    unit: "learners",
  },
  {
    id: "completion-80pct",
    pillar: "employability",
    label: "Maintain 80%+ course completion rate across skilling cohorts",
    targetYear: 2026,
    target: 80,
    actual: 76,
    unit: "%",
  },

  // ─── Entrepreneurship ───────────────────────────────────────────────────────
  {
    id: "farmer-21k",
    pillar: "entrepreneurship",
    label: "Enhance income for 21,000 rural farmers, women & artisans",
    targetYear: 2026,
    target: 21000,
    actual: 18300,
    unit: "people",
  },
  {
    id: "shg-1k",
    pillar: "entrepreneurship",
    label: "Federate 1,000 Women SHGs into market-linked clusters",
    targetYear: 2026,
    target: 1000,
    actual: 820,
    unit: "SHGs",
  },
  {
    id: "hectares-1k",
    pillar: "entrepreneurship",
    label: "Bring 1,000 hectares under regenerative agriculture",
    targetYear: 2027,
    target: 1000,
    actual: 720,
    unit: "hectares",
  },
  {
    id: "artisans-ecom-5k",
    pillar: "entrepreneurship",
    label: "Onboard 5,000 artisans to e-commerce platforms",
    targetYear: 2027,
    target: 5000,
    actual: 4300,
    unit: "artisans",
  },
  {
    id: "income-100cr",
    pillar: "entrepreneurship",
    label: "Unlock ₹100 Cr in cumulative livelihood income for beneficiaries",
    targetYear: 2027,
    target: 100,
    actual: 64,
    unit: "₹ Cr",
  },
  {
    id: "finlit-8k",
    pillar: "entrepreneurship",
    label: "Train 8,000 rural women in financial literacy",
    targetYear: 2026,
    target: 8000,
    actual: 5400,
    unit: "women",
  },

  // ─── Environment Sustainability ─────────────────────────────────────────────
  {
    id: "trees-1m",
    pillar: "environment",
    label: "Plant 1 million fruit trees on farmers' land",
    targetYear: 2028,
    target: 1000000,
    actual: 815000,
    unit: "trees",
  },
  {
    id: "msme-500",
    pillar: "environment",
    label: "Reach 500+ MSMEs for energy efficiency",
    targetYear: 2026,
    target: 500,
    actual: 520,
    unit: "MSMEs",
  },
  {
    id: "co2-5000t",
    pillar: "environment",
    label: "Sequester 5,000 tonnes of CO₂ annually",
    targetYear: 2027,
    target: 5000,
    actual: 3800,
    unit: "tonnes",
  },
  {
    id: "kwh-2m",
    pillar: "environment",
    label: "Save 2 million kWh of energy annually via MSME retrofits",
    targetYear: 2027,
    target: 2000000,
    actual: 1400000,
    unit: "kWh",
  },
  {
    id: "villages-1500",
    pillar: "environment",
    label: "Reach 1,500 villages with climate-resilience interventions",
    targetYear: 2028,
    target: 1500,
    actual: 1200,
    unit: "villages",
  },
  {
    id: "model-villages-12",
    pillar: "environment",
    label: "Establish 12 climate-resilient model villages with full audits",
    targetYear: 2028,
    target: 12,
    actual: 8,
    unit: "villages",
  },
];
